import axios from 'axios';
import { events } from '_events';
import { ROUTES } from '_constants';
import { toast } from 'react-toastify';

import { API_CSRF_TOKEN_KEY, COOKIE_CSRF_TOKEN_VALUE } from '_constants';

export const axiosInstance = axios.create({
  baseURL: '/api',
  headers: { [API_CSRF_TOKEN_KEY]: COOKIE_CSRF_TOKEN_VALUE }
});

const handleError = error => {
  let parsedError = error.response;
  events.toggleErrorModal(parsedError);
  const status = error.response?.status;
  const AUTH_ROUTES = [
    ROUTES.AUTH,
    ROUTES.SIGN_UP,
    ROUTES.SIGN_UP_CONFIRM,
    ROUTES.RESET_PASSWORD,
    ROUTES.FORGOT_PASSWORD,
    ROUTES.CONFIRM_PASSWORD
  ];

  const isAuthRoute = path => {
    return AUTH_ROUTES.some(route => path.startsWith(route));
  };

  // In your interceptor
  if ((status === 401 || status === 403) && !isAuthRoute(window.location.pathname)) {
    window.location.href = ROUTES.AUTH;
    return Promise.reject(error);
  }

  if (error.response.data.detail) {
    parsedError = error.response.data.detail;
    console.log('error:', parsedError);
  }

  if (error.response.data?.non_field_errors) {
    parsedError = error.response.data.non_field_errors[0];
    console.log('error1:', parsedError);
  }

  return Promise.reject(parsedError);
};

axiosInstance.interceptors.request.use(request => request, handleError);

axiosInstance.interceptors.response.use(response => {
  if (
    response.config.method !== 'get' &&
    !response.config.url.includes('login') &&
    !response.config.url.includes('logout')
  ) {
    toast.success(response.data.message || 'Success!');
  }
  return response;
}, handleError);
